module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst field = model.fields[formMapping.modelFieldIndex]\nconst fieldConfig = field.config || {}\nlet translationKey = false\nconst langCode = storage.langCode || 'de-at'\nlet value = '-'\nlet additionalStyle = ''\nconst additionalStyles = []\nlet fieldPath = false\nlet useValueAsTitleGranted = true\nif(field.atom){\nif(fieldConfig.tagBubbleList){\nif(resourceData.value && field.atom.dataType === 'tag-picker') {\nlet e, entity, categoryID, categoryDataID\nlet o, option, categoryNameFound = false\nlet c, child\nconst bubbles = {}\nfor(e in resourceData.value){\nentity = String(resourceData.value[e] || '').split('_') || []\ncategoryID = entity[0] || 0\ncategoryDataID = entity[1] || 0\nif(categoryID && categoryDataID){\nfor(o in (field['tag-picker-data'] || {}).options || []){\nif((option = field['tag-picker-data'].options[o]).id == categoryID){\nfor(c in option.children || []){\nif((child = option.children[c] || {}).id == categoryDataID){\nbubbles[categoryID] = bubbles[categoryID] || { name: option.name, children: {}}\nbubbles[categoryID].children[categoryDataID] = child.name\nbreak;\n}\n}\nbreak;\n}\n}\n}\n}\nlet bubblesHtml = ''\n// run through options instead of bubbles to preserve right category order.\n// TODO: categoryData should be ordered by their sort (within options) too!\nfor(o in (field['tag-picker-data'] || {}).options || []){\noptions = field['tag-picker-data'].options[o] || {}\ncategoryID = options.id\nif(bubbles[categoryID]){\nbubblesHtml += `<div class=\"bubbles\"><div class=\"bubbleParent\">${bubbles[categoryID].name}:</div>`\nfor(categoryDataID in bubbles[categoryID].children){\nbubblesHtml += `<div class=\"bubble\" data-tag-key=\"${categoryID}_${categoryDataID}\">${bubbles[categoryID].children[categoryDataID]}</div>`\n}\nbubblesHtml += `</div>`\n}\n}\nif(bubblesHtml){\nlet additionalBubbleContainerStyles = ['bubbleContainer']\nif(fieldConfig.tagBubbleList.additionalStyles){\nif(Array.isArray(fieldConfig.tagBubbleList.additionalStyles)){\nadditionalBubbleContainerStyles = additionalBubbleContainerStyles.concat(fieldConfig.tagBubbleList.additionalStyles)\n} else {\nadditionalBubbleContainerStyles.push(String(fieldConfig.tagBubbleList.additionalStyles))\n}\n}\nvalue = `<div class=\"${additionalBubbleContainerStyles.join(' ')}\">${bubblesHtml}</div>`\nuseValueAsTitleGranted = false\n}\n}\n} else if(model.singleValue){\nif((resourceData.value || fieldConfig.useFieldPathIfEmpty) && fieldConfig.fieldPath) {\nfieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n}\nelse if(field.atom.dataType === 'boolean'){\ntranslationKey = 'dataValues.' + field.atom.dataType + '.' + resourceData.value;\n}\nelse if(resourceData.value && field.atom.dataType === 'category-picker' || field.atom.dataType === 'resource-picker') {\nlet dataFlag = ''\nif(field.atom.dataType === 'category-picker'){\ndataFlag = 'category-picker-data'\n} else if(field.atom.dataType === 'resource-picker'){\ndataFlag = 'resource-picker-data'\n}\nlet o, option, nameFound = false\nconst resourceValueIsNumber = (typeof resourceData.value === 'number')\nlet comparisonValue\nfor(o in (field[dataFlag] || {}).options || []){\noption = field[dataFlag].options[o]\nif(resourceValueIsNumber)   comparisonValue = option.value * 1;\nelse                        comparisonValue = option.value;\nif(comparisonValue === resourceData.value){\nif(option.color)                             additionalStyles.push('background-color: ' + option.color);\nif((option.config || {}).complementaryColor) additionalStyles.push('color: ' + option.config.complementaryColor);\nif(((option.lang || {})[langCode] || {}).name){\nvalue = option.lang[langCode].name;\nnameFound = true;\n} else if (option.name){\nvalue = option.name;\nnameFound = true;\n}\nbreak;\n}\n}\nif(!nameFound) value = '-';\n}\nelse if(resourceData.value && field.atom.dataType === 'datetime') {\nvalue = utils.moment(resourceData.value).format(fieldConfig.momentDateFormat || 'DD.MM.YYYY');\n}\nelse if(resourceData.value && field.atom.dataType === 'json'){\nvalue = JSON.stringify(resourceData.value);\n}\nelse if(field.atom.dataType === 'text' || field.atom.dataType === 'integer' || field.atom.dataType === 'float') {\nif(!resourceData.value || resourceData.value === null || (typeof(resourceData.value) === 'object' && Object.keys(resourceData.value) <= 0)) {\nif(resourceData.value !== null && resourceData.value !== undefined && (field.atom.dataType === 'integer' || field.atom.dataType === 'float')){\nvalue = utils.number.format(resourceData.value, fieldConfig.currencyFormat || fieldConfig.format || {}, field.atom.dataType).formatted\n} else {\nvalue = '-';\n}\n} else if(field.atom.dataType === 'integer' || field.atom.dataType === 'float'){\nvalue = utils.number.format(resourceData.value, fieldConfig.currencyFormat || fieldConfig.format || {}, field.atom.dataType).formatted\n} else {\nvalue = resourceData.value;\n}\nif(field.atom.dataType === 'text' && fieldConfig.translationBaseKey){\nif(!value || value === '-'){\nvalue = 'all'\n}\ntranslationKey = `${fieldConfig.translationBaseKey}${value}`\n}\n}\n}\nelse if(\nutils.collectionSize(fieldConfig.separatedFieldCodes) > 0\n&&\n(\nfield.atom.renderType === 'period-air'\n)\n){\nconst data = {}\nfor(const fieldTargetKey in fieldConfig.separatedFieldCodes){\nconst valuePart = ((resourceData || {}).attributes || {})[fieldConfig.separatedFieldCodes[fieldTargetKey] || '-NOT_EXISTING_FIELD-']\nif(valuePart !== undefined){\ndata[fieldTargetKey] = valuePart\n}\n}\nif(field.atom.renderType === 'period-air'){\nconst valueParts = []\nif(data.from){\nvalueParts.push(utils.moment(data.from).format(fieldConfig.momentDateFormat || 'DD.MM.YYYY'));\n} else {\nvalueParts.push('');\n}\nif(data.to){\nvalueParts.push(utils.moment(data.to).format(fieldConfig.momentDateFormat || 'DD.MM.YYYY'));\n} else {\nvalueParts.push('');\n}\nvalue = valueParts.join(' - ')\n}\n}\nelse if(field.atom.dataType === 'custom'){\nif(fieldConfig.tagBubbleList && resourceData){\nconst categories = (((resourceData || {}).children || {}).cms_entities_categories || {}).data || []\nlet bubbles = [], showIDs, categoryData, tag, c, tagKey, categoryEntityAttributes;\nif(categories.length > 0){\nshowIDs = helpers.hasRoleOption('showIDs')\nfor(c in categories){\ncategoryEntityAttributes = categories[c].attributes || {}\ncategoryData = ((categories[c].children || {}).cms_categoriesData || {}).data || {};\ntag = (((categoryData.attributes || {}).trls || {})[langCode] || {}).name || 'UNKNOWN_TAG'\ntagKey = ''\nif(categoryEntityAttributes.categoryID && categoryEntityAttributes.categoryDataID){\ntagKey = `${categoryEntityAttributes.categoryID}_${categoryEntityAttributes.categoryDataID}`\n}\nif(showIDs){\ntag = '[' + (categoryData.attributes || {})[categoryData.primaryKey || 'categoryDataID'] + '] ' + tag\n}\nbubbles.push('<div class=\"bubble\" data-tag-key=\"' + tagKey + '\">' + tag + '</div>');\n}\nvalue = '<div class=\"bubbles\">' + (bubbles.join('') || '') + '</div>';\nuseValueAsTitleGranted = false\n} else {\nvalue = ''\n}\n} else if (fieldConfig.fieldPath){\nfieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n} else {\nvalue = '-';\n}\n} else {\nvalue = '-';\n}\n}\n// ellipsis should usually be used by default\nlet defaultColClass = ''\nif(field.atom.dataType !== 'custom'){\ndefaultColClass = 'ellipsis'\n}\nconst colClass = fieldConfig.colClass || defaultColClass\nconst isEllipsis = colClass === 'ellipsis'\nconst additionalClasses = []\nif(fieldConfig.minWidth){\nadditionalStyles.push('min-width: ' + fieldConfig.minWidth);\n}\nif(fieldConfig.width){\nadditionalStyles.push('width: ' + fieldConfig.width);\n}\nif(fieldConfig.maxWidth){\nadditionalStyles.push('max-width: ' + fieldConfig.maxWidth);\n}\nif(additionalStyles.length > 0){\nadditionalStyle = ' style=\"' + additionalStyles.join(';') + '\"';\n}\nif(field.fieldCode){\nif(fieldConfig.parentJSONFieldCode){\nadditionalClasses.push(`fieldOf_${fieldConfig.parentJSONFieldCode}_${field.fieldCode}`);\n} else {\nadditionalClasses.push(`fieldOf_${field.fieldCode}`);\n}\n}\nif(colClass) additionalClasses.push(colClass);\nlet colSpan = 1;\nlet rowSpan = 1;\nif(fieldConfig.colSpan) colSpan = fieldConfig.colSpan;\nif(fieldConfig.rowSpan) rowSpan = fieldConfig.rowSpan;\nif(fieldConfig.textAlign === 'right')       additionalClasses.push('textAlignRight')\nelse if(fieldConfig.textAlign === 'center') additionalClasses.push('textAlignCenter')\nif(fieldConfig.optionalIfEmpty && !fieldPath && (!value || value === '-')){\nadditionalClasses.push('isOptionalAndEmpty')\n}\nif(translationKey){\nvalue = storage.__(translationKey, { value })\n}\nuseValueAsTitleGranted = useValueAsTitleGranted && value && value !== '-' && isEllipsis\n%><td colspan=\"<%= colSpan %>\" rowspan=\"<%= rowSpan %>\" data-model-field-index=\"<%= formMapping.modelFieldIndex %>\" class=\"<%= additionalClasses.join(' '); %>\" title=\"<%= (useValueAsTitleGranted ? value : '') %>\"<%- additionalStyle %>><%\nif (fieldPath) {\n%><%- include(fieldPath, { model: field, config: fieldConfig.componentConfig || {}, resourceData: resourceData, rowResourceData }); %><%\n} else {\n%><%- value %><%\n}\n%></td>"
  , __filename = "..\\frontend-controller\\baseComponents\\tableSimple\\col.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const field = model.fields[formMapping.modelFieldIndex]
const fieldConfig = field.config || {}
let translationKey = false
const langCode = storage.langCode || 'de-at'
let value = '-'
let additionalStyle = ''
const additionalStyles = []
let fieldPath = false
let useValueAsTitleGranted = true
if(field.atom){
if(fieldConfig.tagBubbleList){
if(resourceData.value && field.atom.dataType === 'tag-picker') {
let e, entity, categoryID, categoryDataID
let o, option, categoryNameFound = false
let c, child
const bubbles = {}
for(e in resourceData.value){
entity = String(resourceData.value[e] || '').split('_') || []
categoryID = entity[0] || 0
categoryDataID = entity[1] || 0
if(categoryID && categoryDataID){
for(o in (field['tag-picker-data'] || {}).options || []){
if((option = field['tag-picker-data'].options[o]).id == categoryID){
for(c in option.children || []){
if((child = option.children[c] || {}).id == categoryDataID){
bubbles[categoryID] = bubbles[categoryID] || { name: option.name, children: {}}
bubbles[categoryID].children[categoryDataID] = child.name
break;
}
}
break;
}
}
}
}
let bubblesHtml = ''
// run through options instead of bubbles to preserve right category order.
// TODO: categoryData should be ordered by their sort (within options) too!
for(o in (field['tag-picker-data'] || {}).options || []){
options = field['tag-picker-data'].options[o] || {}
categoryID = options.id
if(bubbles[categoryID]){
bubblesHtml += `<div class="bubbles"><div class="bubbleParent">${bubbles[categoryID].name}:</div>`
for(categoryDataID in bubbles[categoryID].children){
bubblesHtml += `<div class="bubble" data-tag-key="${categoryID}_${categoryDataID}">${bubbles[categoryID].children[categoryDataID]}</div>`
}
bubblesHtml += `</div>`
}
}
if(bubblesHtml){
let additionalBubbleContainerStyles = ['bubbleContainer']
if(fieldConfig.tagBubbleList.additionalStyles){
if(Array.isArray(fieldConfig.tagBubbleList.additionalStyles)){
additionalBubbleContainerStyles = additionalBubbleContainerStyles.concat(fieldConfig.tagBubbleList.additionalStyles)
} else {
additionalBubbleContainerStyles.push(String(fieldConfig.tagBubbleList.additionalStyles))
}
}
value = `<div class="${additionalBubbleContainerStyles.join(' ')}">${bubblesHtml}</div>`
useValueAsTitleGranted = false
}
}
} else if(model.singleValue){
if((resourceData.value || fieldConfig.useFieldPathIfEmpty) && fieldConfig.fieldPath) {
fieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
}
else if(field.atom.dataType === 'boolean'){
translationKey = 'dataValues.' + field.atom.dataType + '.' + resourceData.value;
}
else if(resourceData.value && field.atom.dataType === 'category-picker' || field.atom.dataType === 'resource-picker') {
let dataFlag = ''
if(field.atom.dataType === 'category-picker'){
dataFlag = 'category-picker-data'
} else if(field.atom.dataType === 'resource-picker'){
dataFlag = 'resource-picker-data'
}
let o, option, nameFound = false
const resourceValueIsNumber = (typeof resourceData.value === 'number')
let comparisonValue
for(o in (field[dataFlag] || {}).options || []){
option = field[dataFlag].options[o]
if(resourceValueIsNumber)   comparisonValue = option.value * 1;
else                        comparisonValue = option.value;
if(comparisonValue === resourceData.value){
if(option.color)                             additionalStyles.push('background-color: ' + option.color);
if((option.config || {}).complementaryColor) additionalStyles.push('color: ' + option.config.complementaryColor);
if(((option.lang || {})[langCode] || {}).name){
value = option.lang[langCode].name;
nameFound = true;
} else if (option.name){
value = option.name;
nameFound = true;
}
break;
}
}
if(!nameFound) value = '-';
}
else if(resourceData.value && field.atom.dataType === 'datetime') {
value = utils.moment(resourceData.value).format(fieldConfig.momentDateFormat || 'DD.MM.YYYY');
}
else if(resourceData.value && field.atom.dataType === 'json'){
value = JSON.stringify(resourceData.value);
}
else if(field.atom.dataType === 'text' || field.atom.dataType === 'integer' || field.atom.dataType === 'float') {
if(!resourceData.value || resourceData.value === null || (typeof(resourceData.value) === 'object' && Object.keys(resourceData.value) <= 0)) {
if(resourceData.value !== null && resourceData.value !== undefined && (field.atom.dataType === 'integer' || field.atom.dataType === 'float')){
value = utils.number.format(resourceData.value, fieldConfig.currencyFormat || fieldConfig.format || {}, field.atom.dataType).formatted
} else {
value = '-';
}
} else if(field.atom.dataType === 'integer' || field.atom.dataType === 'float'){
value = utils.number.format(resourceData.value, fieldConfig.currencyFormat || fieldConfig.format || {}, field.atom.dataType).formatted
} else {
value = resourceData.value;
}
if(field.atom.dataType === 'text' && fieldConfig.translationBaseKey){
if(!value || value === '-'){
value = 'all'
}
translationKey = `${fieldConfig.translationBaseKey}${value}`
}
}
}
else if(
utils.collectionSize(fieldConfig.separatedFieldCodes) > 0
&&
(
field.atom.renderType === 'period-air'
)
){
const data = {}
for(const fieldTargetKey in fieldConfig.separatedFieldCodes){
const valuePart = ((resourceData || {}).attributes || {})[fieldConfig.separatedFieldCodes[fieldTargetKey] || '-NOT_EXISTING_FIELD-']
if(valuePart !== undefined){
data[fieldTargetKey] = valuePart
}
}
if(field.atom.renderType === 'period-air'){
const valueParts = []
if(data.from){
valueParts.push(utils.moment(data.from).format(fieldConfig.momentDateFormat || 'DD.MM.YYYY'));
} else {
valueParts.push('');
}
if(data.to){
valueParts.push(utils.moment(data.to).format(fieldConfig.momentDateFormat || 'DD.MM.YYYY'));
} else {
valueParts.push('');
}
value = valueParts.join(' - ')
}
}
else if(field.atom.dataType === 'custom'){
if(fieldConfig.tagBubbleList && resourceData){
const categories = (((resourceData || {}).children || {}).cms_entities_categories || {}).data || []
let bubbles = [], showIDs, categoryData, tag, c, tagKey, categoryEntityAttributes;
if(categories.length > 0){
showIDs = helpers.hasRoleOption('showIDs')
for(c in categories){
categoryEntityAttributes = categories[c].attributes || {}
categoryData = ((categories[c].children || {}).cms_categoriesData || {}).data || {};
tag = (((categoryData.attributes || {}).trls || {})[langCode] || {}).name || 'UNKNOWN_TAG'
tagKey = ''
if(categoryEntityAttributes.categoryID && categoryEntityAttributes.categoryDataID){
tagKey = `${categoryEntityAttributes.categoryID}_${categoryEntityAttributes.categoryDataID}`
}
if(showIDs){
tag = '[' + (categoryData.attributes || {})[categoryData.primaryKey || 'categoryDataID'] + '] ' + tag
}
bubbles.push('<div class="bubble" data-tag-key="' + tagKey + '">' + tag + '</div>');
}
value = '<div class="bubbles">' + (bubbles.join('') || '') + '</div>';
useValueAsTitleGranted = false
} else {
value = ''
}
} else if (fieldConfig.fieldPath){
fieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
} else {
value = '-';
}
} else {
value = '-';
}
}
// ellipsis should usually be used by default
let defaultColClass = ''
if(field.atom.dataType !== 'custom'){
defaultColClass = 'ellipsis'
}
const colClass = fieldConfig.colClass || defaultColClass
const isEllipsis = colClass === 'ellipsis'
const additionalClasses = []
if(fieldConfig.minWidth){
additionalStyles.push('min-width: ' + fieldConfig.minWidth);
}
if(fieldConfig.width){
additionalStyles.push('width: ' + fieldConfig.width);
}
if(fieldConfig.maxWidth){
additionalStyles.push('max-width: ' + fieldConfig.maxWidth);
}
if(additionalStyles.length > 0){
additionalStyle = ' style="' + additionalStyles.join(';') + '"';
}
if(field.fieldCode){
if(fieldConfig.parentJSONFieldCode){
additionalClasses.push(`fieldOf_${fieldConfig.parentJSONFieldCode}_${field.fieldCode}`);
} else {
additionalClasses.push(`fieldOf_${field.fieldCode}`);
}
}
if(colClass) additionalClasses.push(colClass);
let colSpan = 1;
let rowSpan = 1;
if(fieldConfig.colSpan) colSpan = fieldConfig.colSpan;
if(fieldConfig.rowSpan) rowSpan = fieldConfig.rowSpan;
if(fieldConfig.textAlign === 'right')       additionalClasses.push('textAlignRight')
else if(fieldConfig.textAlign === 'center') additionalClasses.push('textAlignCenter')
if(fieldConfig.optionalIfEmpty && !fieldPath && (!value || value === '-')){
additionalClasses.push('isOptionalAndEmpty')
}
if(translationKey){
value = storage.__(translationKey, { value })
}
useValueAsTitleGranted = useValueAsTitleGranted && value && value !== '-' && isEllipsis

    ; __line = 229
    ; __append("<td colspan=\"")
    ; __append(escapeFn( colSpan ))
    ; __append("\" rowspan=\"")
    ; __append(escapeFn( rowSpan ))
    ; __append("\" data-model-field-index=\"")
    ; __append(escapeFn( formMapping.modelFieldIndex ))
    ; __append("\" class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\" title=\"")
    ; __append(escapeFn( (useValueAsTitleGranted ? value : '') ))
    ; __append("\"")
    ; __append( additionalStyle )
    ; __append(">")
    ; 
if (fieldPath) {

    ; __line = 231
    ; __append( include(fieldPath, { model: field, config: fieldConfig.componentConfig || {}, resourceData: resourceData, rowResourceData }) )
    ; 
} else {

    ; __line = 233
    ; __append( value )
    ; 
}

    ; __line = 235
    ; __append("</td>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\tableSimple\col.ejs

}